import { UserModel } from '$tablet-app/src/app/auth/UserModel';
import { palette } from '$tablet-app/src/app/theme';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import ChatScreenAvatarColumn from './ChatScreenAvatarColumn';
import ChatScreenHeader from './ChatScreenHeader';
import ChatSection, { ChatSectionProps } from './ChatSection';

interface Props extends ChatSectionProps {
  user?: UserModel;
  avatar_expression?: string;
  two_columns?: boolean;
  onClose?: () => any;
}

const ChatScreenView = (props: Props) => {
  const {
    user,
    avatar_expression,
    two_columns = true,

    // Shared between chat_props and others
    mic_active = false,
    onClose,

    ...chat_props
  } = props;

  return (
    <View
      style={[
        styles.container,
        two_columns ? styles.columnView : styles.rowView,
      ]}
    >
      {two_columns ? (
        <ChatScreenAvatarColumn
          user={user}
          avatar_expression={avatar_expression}
          mic_active={mic_active}
        />
      ) : (
        <ChatScreenHeader mic_active={mic_active} onRequestClose={onClose} />
      )}

      <ChatSection
        style={!two_columns ? styles.noTopPadding : undefined}
        mic_active={mic_active}
        onClose={onClose}
        {...chat_props}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  noTopPadding: {
    paddingTop: 0,
  },
  container: {
    backgroundColor: `${palette.white}`,
    height: '100%',
  },
  columnView: {
    flexDirection: 'row',
  },
  rowView: {
    flexDirection: 'column',
  },
});

export default ChatScreenView;
